import React, { useContext, useEffect, useState } from "react";
import styles from "./manageproperties.module.scss";
import ToastContext from "../../contexts/ToastContext";
import LoadingContext from "../../contexts/LoadingContext";
import { Property } from "../../types/Property";
import { PaginationParamsPersonalizedProperties } from "../../types/propertyType";
import { getMortgageListingsApi } from "../../swr/properties";
import PropertyCard from "../../components/PropertyCard";
import Stack from "@mui/system/Stack";
import Pagination from "@mui/material/Pagination";
import { useQuery } from "../../hooks/useQuery";
 
const Index = () => {
  let query = useQuery();
  let redirect = query.get("morf");
  
  const { openError } = useContext(ToastContext);
  const { setLoading } = useContext(LoadingContext);
  const [paginationParams, setPaginationParams] = useState({
    PageNumber: 1,
    PageSize: 9,
  });

  const token = localStorage.getItem("token") as string;

  const [properties, setProperties] = useState<Property[] | []>([]);
  const [pageParams, setPageParams] = useState(
    {} as PaginationParamsPersonalizedProperties
  );

  const getMortgagedProperties = async () => {
    setLoading(true);
    const response = await getMortgageListingsApi(paginationParams, token);

    if (!response) {
      setLoading(false);
      openError("Unable to fetch mortgage properties");
      return;
    }

    if (response.item1) {
      setLoading(false);
      setProperties(response.item1);
      return;
    }

    if (response.item2) {
      setLoading(false);
      setPageParams(response.item2);
      return;
    }

    openError("Unable to fetch mortgage properties");
    setLoading(false);
    return;
  }; 

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPaginationParams((prev) => ({ ...prev, PageNumber: newPage }));
  };

  const returnProperties = (mortgagedProperties: Property[]) => {
    return mortgagedProperties.map((prop) => (
      <PropertyCard
        property={prop} 
        key={prop.title}
        isHomeBuddyMortgage={redirect === "homebuddy-mort"}
      />
    ));
  }; 

  useEffect(() => {
    getMortgagedProperties();
    if (paginationParams.PageNumber > 0) {
      getMortgagedProperties();
    }
  }, []);

  return (
    <div className={styles.overallContainer}>
      {properties && properties.length > 0 ? (
        <>
          <div className={styles.container}>{returnProperties(properties)}</div>
          <div className={styles.paginationDiv}>
            {!(
              paginationParams.PageNumber == 1 &&
              properties &&
              properties.length < paginationParams.PageSize
            ) && (
              <Stack
                spacing={2}
                sx={{ marginBottom: "30px", alignItems: "center" }}
              >
                <Pagination
                  count={pageParams && pageParams.totalPages}
                  page={paginationParams.PageNumber}
                  onChange={handlePageChange}
                  size={"large"}
                  variant="outlined"
                  color="standard"
                />
              </Stack>
            )}
          </div>
        </>
      ) : (
        <div className={styles.noListing}>
          <span className={styles.fonts}>
            No Mortgaged Properties Available
          </span>
        </div>
      )}
    </div>
  );
};

export default Index;
